import React from 'react';
import { observer } from 'mobx-react';
import EngravePopup, { IProps } from './EngravePopup';

export default observer((props: IProps) => {
  return <EngravePopup {...props} />;
});
